import { useContext, useEffect } from 'react';
import { AuthContext } from '../utils/auth.js';
import { syncAdminDevTools } from '../utils/adminDevTools.js';

export default function AdminDevToolsSync() {
  const { currentUser } = useContext(AuthContext);

  useEffect(() => {
    syncAdminDevTools(currentUser?.email, { authPending: false });
  }, [currentUser?.email]);

  return null;
}
